import React from 'react';
import { Route, Navigate } from 'react-router-dom';
import OrgRepRoute from '../../components/OrgRepRoute';
import {
  RedirectFortDetailToCanonical,
  RedirectOrganizationDetailToCanonical,
  RedirectToForts,
} from '../canonicalRoutes';
import { withSuspense } from '../routeHelpers';
import * as Pages from '../lazyPages/public';
import * as MobilePages from '../lazyPages/mobile';
import { isShopEnabled } from '../../config/featureFlags';

/** Returns a Fragment of Route elements — must be invoked inline inside <Routes>, not as a wrapper component. */
export function getPublicRoutes(native) {
  return (
    <>
      <Route
        path="/"
        element={withSuspense(native ? <MobilePages.MobileHomePage /> : <Pages.Home />)}
      />
      <Route path="/forts" element={withSuspense(<Pages.Forts />)} />
      <Route path="/all-forts" element={<RedirectToForts />} />
      <Route path="/fort/:id" element={withSuspense(<Pages.FortDetail />)} />
      <Route path="/temples" element={withSuspense(<Pages.Temples />)} />
      <Route path="/wades" element={withSuspense(<Pages.Wades />)} />
      <Route path="/wades/:id" element={withSuspense(<Pages.WadaDetail />)} />
      <Route path="/temples/:id" element={withSuspense(<Pages.TempleDetail />)} />
      <Route path="/search" element={withSuspense(<Pages.SearchResults />)} />
      <Route path="/about" element={withSuspense(<Pages.About />)} />
      <Route path="/contact" element={withSuspense(<Pages.Contact />)} />
      <Route path="/emergency" element={withSuspense(<Pages.EmergencyHubPage />)} />
      <Route path="/blog" element={withSuspense(<Pages.BlogPage />)} />
      <Route path="/blog/:id" element={withSuspense(<Pages.BlogDetail />)} />
      <Route path="/heritage" element={withSuspense(<Pages.HeritageHub />)} />
      <Route path="/heritage/bhakta-gadkot" element={withSuspense(<Pages.BhaktaGadkotHub />)} />
      <Route path="/heritage/sardars" element={withSuspense(<Pages.SardarsHub />)} />
      <Route path="/heritage/sardars/:slug" element={withSuspense(<Pages.SardarDetail />)} />
      <Route path="/heritage/places" element={withSuspense(<Pages.HistoricPlacesHub />)} />
      <Route path="/heritage/places/:slug" element={withSuspense(<Pages.HistoricPlaceDetail />)} />
      <Route path="/heritage/partners" element={withSuspense(<Pages.HeritagePartners />)} />
      <Route path="/heritage/visit-planning" element={withSuspense(<Pages.VisitPlanningHub />)} />
      <Route path="/heritage/gallery" element={withSuspense(<Pages.HeritageGalleryPage />)} />
      <Route path="/books" element={withSuspense(<Pages.BooksLibraryPage />)} />
      <Route path="/books/:slug" element={withSuspense(<Pages.BookReaderPage />)} />
      <Route path="/history" element={withSuspense(<Pages.HistoryPage />)} />
      <Route path="/history/tithi-calendar" element={withSuspense(<Pages.TithiYearCalendar />)} />
      <Route path="/history/tithi-compendium" element={withSuspense(<Pages.TithiHistoryCompendium />)} />
      <Route path="/history/india-map" element={withSuspense(<Pages.IndiaHistoricMapPage />)} />
      <Route path="/history/daily/:id" element={withSuspense(<Pages.DailyHistoryDetail />)} />
      <Route path="/history/:slug" element={withSuspense(<Pages.HistoryDetail />)} />
      <Route path="/organizations" element={withSuspense(<Pages.OrganizationsPage />)} />
      <Route
        path="/organizations/category/:categoryCode"
        element={withSuspense(<Pages.OrganizationsPage />)}
      />
      <Route path="/organizations/org/:slug" element={withSuspense(<Pages.OrganizationDetail />)} />
      <Route path="/organizations/detail/:id" element={<RedirectOrganizationDetailToCanonical />} />
      <Route
        path="/organizations/manage"
        element={withSuspense(
          <OrgRepRoute>
            <Pages.OrganizationRepPortalPage />
          </OrgRepRoute>
        )}
      />
      <Route path="/events" element={withSuspense(<Pages.EventsCalendarPage />)} />
      {isShopEnabled() ? (
        <>
          <Route path="/shop" element={withSuspense(<Pages.ShopPage />)} />
          <Route path="/shop/checkout" element={withSuspense(<Pages.ShopCheckoutPage />)} />
          <Route path="/shop/order/:orderCode" element={withSuspense(<Pages.ShopOrderSuccess />)} />
          <Route path="/shop/:slug" element={withSuspense(<Pages.ShopProductDetail />)} />
        </>
      ) : (
        <Route path="/shop/*" element={<Navigate to="/" replace />} />
      )}
      <Route path="/weapons" element={withSuspense(<Pages.WeaponsList />)} />
      <Route path="/weapons/category/:categoryId" element={withSuspense(<Pages.WeaponsList />)} />
      <Route path="/weapons/:id" element={withSuspense(<Pages.WeaponDetails />)} />
      <Route path="/trek-planner" element={withSuspense(<Pages.TrekPlanner />)} />
      <Route path="/fort-guide" element={withSuspense(<Pages.FortGuidePage />)} />
      <Route path="/community" element={withSuspense(<Pages.CommunityHubPage />)} />
      <Route path="/trek/live/:token" element={withSuspense(<Pages.TrekLiveShare />)} />
      <Route path="/contributions" element={withSuspense(<Pages.UserContributions />)} />
      <Route path="/quiz" element={withSuspense(<Pages.Quiz />)} />
      <Route path="/short-notes" element={withSuspense(<Pages.ShortNotes />)} />
      <Route path="/learn" element={withSuspense(<Pages.LearnSection />)} />
      <Route path="/education/institutions" element={withSuspense(<Pages.InstitutionPortalPage />)} />
      <Route path="/audiobooks" element={withSuspense(<Pages.AudiobookLibraryPage />)} />
      <Route path="/fort-detail/:id" element={<RedirectFortDetailToCanonical />} />
      <Route path="/nearby-forts" element={withSuspense(<Pages.NearbyForts />)} />
      <Route path="/badges" element={withSuspense(<Pages.BadgesSystem />)} />
      <Route path="/geographic-explorer" element={withSuspense(<Pages.GeographicExplorer />)} />
      <Route path="/thematic-routes" element={withSuspense(<Pages.ThematicRoutes />)} />
      <Route path="/thematic-routes/:routeId" element={withSuspense(<Pages.ThematicRouteDetail />)} />
      <Route path="/bookings/lookup" element={withSuspense(<Pages.BookingLookup />)} />
      <Route path="/bookings/:code" element={withSuspense(<Pages.BookingLookup />)} />
      <Route path="/register" element={withSuspense(<Pages.RegisterPage />)} />
      <Route path="/login" element={withSuspense(<Pages.LoginPage />)} />
      <Route path="/profile" element={withSuspense(<Pages.UserProfile />)} />
      <Route path="/wishlist" element={withSuspense(<Pages.WishlistManager />)} />
      <Route path="/planner" element={withSuspense(<Pages.VisitPlanner />)} />
      <Route path="/plan/:code" element={withSuspense(<Pages.SharedTripPlan />)} />
      <Route path="/error/:errorCode" element={withSuspense(<Pages.ErrorPage />)} />
    </>
  );
}
